
export function isValidEmail(email: string) {
  return email.match(/.+@(\b(?!-)[a-zA-z0-9-]+(?!-)\b)?\.([a-z]{2,})/g) !== null;
}

export function isValidPassword(password: string) {
  return password.length >= 8 && !!password.match(/[a-zA-Z]+/g) && !!password.match(/[\d]+/g);
}

export const PASSWORD_REQUIREMENT = "Password must be at least 8 characters with a letter and number";
